<template>
  <div class="br-modal">
    <div class="br-modal__dialog">
      <div class="br-modal__head">
        <span class="br-modal__title">Email List Verification</span>
        <button
          v-modal
          class="button button--icon js-close-modal">
          <i class="icon icon-e-remove"/>
        </button>
      </div>
      <div class="br-modal__body">
        <div class="notice">
          <div class="notice__icon">
            <i class="icon icon-question"/>
          </div>
          <div class="notice__content">
            <p><strong>This Estimate</strong>: We will estimate your setup and monthly cost based on the options you choose below. Any applicable taxes are not included, and your fees are subject to increase with additional purchases. </p>
          </div>
        </div>
        <div class="br-pricing-estimate">
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head">
              <h2>Organization Type</h2>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <div class="form-group">
                <label
                  for="organization_type"
                  class="label">Which option best encompasses your organization?</label>
                <div class="select u-border-radius">
                  <select
                    id="organization_type"
                    v-model.number="model.organization_type"
                    name="organization_type">
                    <option value="1">
                      Non-Profit
                    </option>
                    <option value="2">
                      For-Profit
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head">
              <h2>Email Quantity</h2>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <p>It looks like you are interested in <strong class="u-color-a">{{ model.size | numeral }}</strong> email address to have cleaned and verified.</p>
              <slider
                v-model="model.size"
                type="email"
                :min="5000"
                :max="5000000"/>
            </div>
          </div>
          <div class="br-pricing-estimate__panel">
            <div class="br-pricing-estimate__panel__head br-pricing-estimate__panel__head--break">
              <h2>Cost Breakdown</h2>
              <currency-selector v-model="model.currency"/>
            </div>
            <div class="br-pricing-estimate__panel__body">
              <div class="br-pricing-estimate__summary">
                <div class="br-pricing-estimate__summary__item">
                  <span class="text u-color-green"><i class="icon icon-c-check"/></span>
                  <span class="text">Non-Profit Organization</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">Discount Applied </span>
                    <span class="text text--muted">(monthly savings)</span>
                  </div>
                </div>
                <div class="br-pricing-estimate__summary__item">
                  <span class="text u-color-green"><i class="icon icon-c-check"/></span>
                  <span class="text">Email Address ({{ model.size | numeral }} email)</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">{{ formatNumber(getPerCardCost) }} / email</span>
                    <span class="text text--muted">(billed monthly)</span>
                  </div>
                </div>
                <div class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--alt">
                  <span class="text">Monthly Cost:</span>
                  <div class="text-group-vertical">
                    <span class="text text--highlight">{{ formatNumber(vbcTotal) }}</span>
                    <span class="text text--muted">(billed monthly)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            class="button button--block u-border-radius"
            @click.prevent="redirectPage">
            Talk to Sales
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pricing from '@mixins/Pricing'
import Slider from '@components/Slider'
import ModalMixin from '@mixins/ModalMixin'
import CurrencySelector from '@components/CurrencySelector'

export default {
  components: {
    Slider,
    CurrencySelector
  },
  mixins: [
    ModalMixin,
    Pricing
  ],
  created () {
    this.initExchangeRate()
  },
  methods: {
    redirectPage () {
      this.visit(this.route('schedule-demo', this.generateHash()))
    }
  }
}
</script>
